module.exports = ".link {\n    color: #11C7A9;\n}"